import { createCdnReset, createCdnFont } from './helpers';
import logos from './logos';
var reset = createCdnReset('https://shared.mediahuis.be', ['v1'], 'v1');
var fonts = createCdnFont('https://shared.mediahuis.be', ['v1.0.0'], 'v1.0.0', 'latest', 'wl/');
export default {
  cdn: {
    reset: reset,
    fonts: fonts,
    logos: logos
  }
};